import { create } from "zustand";

export type GetSessionToken = (options?: { skipCache?: boolean }) => Promise<string | null>;

interface AuthState {
    sessionId: string | null;
    getToken: GetSessionToken;
    setSession: (sessionId: string | null, getToken: GetSessionToken) => void;
}

// Clerk owns token storage and refresh. Keep only its token getter in memory.
export const useAuthStore = create<AuthState>((set) => ({
    sessionId: null,
    getToken: async () => null,
    setSession: (sessionId, getToken) => set({ sessionId, getToken }),
}));
